import { render, staticRenderFns } from "./loss.vue?vue&type=template&id=9effaa88&scoped=true"
import script from "./loss.vue?vue&type=script&lang=js"
export * from "./loss.vue?vue&type=script&lang=js"
import style0 from "./loss.vue?vue&type=style&index=0&id=9effaa88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9effaa88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9effaa88')) {
      api.createRecord('9effaa88', component.options)
    } else {
      api.reload('9effaa88', component.options)
    }
    module.hot.accept("./loss.vue?vue&type=template&id=9effaa88&scoped=true", function () {
      api.rerender('9effaa88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/loss.vue"
export default component.exports